<template>
    <div>
        <div class="main-layout campaign-news-page detail-info">
            <div class="row w-100" style="position: absolute">
                <div class="header-page col-12">
                    <a class="btn-back ml-2" @click="backHistory">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M10.6 12.71a1 1 0 0 1 0-1.42l4.59-4.58a1.001 1.001 0 1 0-1.41-1.42L9.19 9.88a3 3 0 0 0 0 4.24l4.59 4.59a1 1 0 0 0 1.41-1.42l-4.59-4.58z"
                                fill="#ffffff"
                            />
                        </svg>
                        <p>ย้อนกลับ</p>
                    </a>
                </div>
            </div>
            <div class="content-news">
                <div class="img">
                    <div class="overlay"></div>
                    <img :src="campaign.fullImageUrl" class="img-news" />
                </div>
                <div class="detail-news" :class="{ short: isNews }">
                    <div class="col-12 text-left pl-0">
                        <div class="title-campaign">
                            {{ campaign.name }}
                        </div>
                        <div
                            class="use-point"
                            v-if="campaign.type != 16 && !isSubscription"
                        >
                            <span>ใช้ {{ campaign.pointPerUnit }} คะแนน</span
                            ><img
                                src="@/assets/profile/point-dark.svg"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="detail-body mt-2">
                        <DetailAndCondition
                            :isSubscription="isSubscription"
                            :lbl="lbl"
                            :campaign="campaign"
                            :hideCondition="hideCondition"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Moment from "moment";
//helper
import Util from "@/helper/Utility.js";
import DetailAndCondition from "@/module/Detail/component/detail/DetailAndCondition.vue";
import CacheHelper from "@/helper/CacheHelper.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";

export default {
    name: "DetailInfo",
    components: {
        DetailAndCondition,
    },
    props: {
        lbl: Object,
        campaign: Object,
        isSubscription: Boolean,
        isNews: Boolean,
        hideCondition: Boolean,
        backRoute: String,
    },
    data() {
        return {
            cacheHelper: new CacheHelper(),
            profile: {},
        };
    },
    created: function () {
        this.getProfile();
    },
    methods: {
        backHistory() {
            if (this.backRoute) {
                this.$router.push(this.backRoute);
            } else {
                this.$router.go(-1);
            }
        },
        getProfile() {
            BzbsApi.getProfile(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                this.profile = response.data;
            });
        },
        getAgencyLogoUrl: function () {
            return `${Vue.bzbsConfig.bzbsBlobUrl}/agencies/${this.campaign.agencyID}`;
        },
        getPointTxt: function () {
            var pointTypeTxt =
                this.campaign.pointType && this.campaign.pointType != "use"
                    ? this.lbl.detail.get_point
                    : this.lbl.detail.use_point;

            var pointUnit =
                this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                    ? this.lbl.detail.point_unit + "s"
                    : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        getExpireDate: function () {
            var expireDate = this.campaign.expireDate;
            var message = this.lbl.detail.expire_date;

            var result = Moment.unix(expireDate);
            var year = Moment.unix(expireDate).format("YYYY");
            if (this.localeCode === 1054) year = result.get("year") + 543;

            year = year.toString().substring(2, 4);
            var month = this.lbl.date.month_full[result.format("M") - 1];
            var day = result.format("DD");
            var date = `${day} ${month} ${year}`;

            return Util.stringFormat(message, date);
        },
        goto(page) {
            this.$router.push("/" + page);
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseText.scss";
@import "@/style/_mixin.scss";
#detail_info {
    padding: {
        left: 15px;
        right: 15px;
    }

    #detail_info_content {
        @extend %display-flex;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        overflow: hidden;
        //font
        font-size: 1rem;
        line-height: 1;

        #info_content_txt {
            width: calc(100% - 80px);
            flex: 0 0 calc(100% - 80px);
            margin: auto 0;
            padding-left: 10px;

            #agency_name {
                font-size: 1.3rem;
            }
        }

        #info_content_logo {
            width: 80px;
            flex: 0 0 80px;

            img {
                width: 100%;
                height: 80px;
                display: block;
            }
        }
    }
}
.campaign-news-page {
    min-height: 100vh;
    .wrapper-header-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 63px;
        .bg-point-user {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .img-bg-point {
                z-index: 1;
                position: absolute;
            }
            .img-coin-user {
                // position: absolute;
                // right: 130px;
                // z-index: 2;
                // margin-top: -3px;
                margin-right: 3px;
                width: 20px;
                height: 20px;
            }
            .span-coin {
                z-index: 2;
                position: absolute;
                margin-top: -3px;
                right: 18px;
                font-size: 18px;
                color: #49883f;
                .value-coin {
                    font-size: 16px;
                    color: #f25228;
                    line-height: 1.05;
                }
            }
        }
    }
    .header-page {
        padding: 15px 20px 0px;
        text-align: center;
        width: 100%;

        .btn-back {
            position: relative;
            z-index: 99;
            background: $color-brown-900;
            border-radius: 25px;
            float: left;
            padding: 0 5px;
            height: 30px;
            line-height: 28px;
            box-shadow: 0px 0px 4px rgba(#65513e, 0.2);
            p {
                color: #fff;
                display: inline-block;
                margin: 0 10px 0 0;
                font-size: 15px;
            }
        }

        .lbl-header {
            font-size: 18px;
            font-family: "PromptSemiBold";
            line-height: 1.15;
            letter-spacing: normal;
            text-align: center;
            color: #044437;
            margin-left: -15px;
        }
    }

    .content-news {
        // padding: 4px 14px 15px;
        img {
            margin-bottom: -15px;
        }
        // .overlay {
        //     width: 100%;
        //     height: 7%;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //     background-image: linear-gradient(
        //         to bottom,
        //         rgba(0, 0, 0, 0.7),
        //         rgba(0, 0, 0, 0.3) 64%,
        //         rgba(0, 0, 0, 0) 100%
        //     );
        // }
        .img-news {
            object-fit: cover;
            width: 100vw;
            height: 100vw;
        }
        @media (max-height: 667px) {
            .img-news {
                object-fit: cover;
                width: 100vw;
                height: 70vw;
            }
        }
        .detail-news {
            padding: 20px;
            border-top-right-radius: 20px;
            border-top-left-radius: 20px;
            background-color: $color-light-grey-500;
            min-height: calc(100vh - 90vw - 15px);
            display: inline-table;
            width: 100%;
            position: fixed;
            bottom: 0;

            @media (max-height: 667px) {
                min-height: calc(100vh - 65vw);
            }
            &.short {
                min-height: calc(100vh - 95vw);
            }
            .detail-header {
                font-size: 28px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
            }

            .detail-body {
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.05;
                letter-spacing: normal;
                text-align: left;
                color: #044437;
                overflow: hidden;
            }

            .use-point {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-family: "PromptSemiBold";

                img {
                    margin: 0;
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
